// This is the root of the entire project, it renders and initializes the App component which includes the entirety of the application

import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/bootstrap.scss";
import "./styles/style.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
